import { render } from "./PlansList.vue?vue&type=template&id=2936d904"
import script from "./PlansList.vue?vue&type=script&lang=js"
export * from "./PlansList.vue?vue&type=script&lang=js"

import exportComponent from "E:\\PhpstormProjects\\zoodkomak_tv_panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__